import React, { useEffect, useRef, useState } from 'react';
import AppStrings from '../../config/appstring';
import DiscountType from '../../Class/DiscountTypes';
import BusSelect from '../../Class/BusList';
import FeesPrint from '../Print/FeesPrint';
import AdditionalTypeList from '../../Class/AdditionalType';
import TermTypeList from '../../Class/TeamList';
import axios from 'axios';
import CancelForm from './Cancel';

function AdditionalFeesForm({ onClose, studentData }) {
  const [admissionDate, setAdmissionDate] = useState(new Date().toISOString().split('T')[0]);
  const [feeDetails, setFeeDetails] = useState([]);
  const [discountModalIndex, setDiscountModalIndex] = useState(null);
  const [tempDiscount, setTempDiscount] = useState('');
  const [tempDiscountType, setTempDiscountType] = useState('');
  const [tempDiscountRemarks, setTempDiscountRemarks] = useState('');
  const discountInputRef = useRef(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [printRefNo, setPrintRefNo] = useState(null);
  const [AddFees, setAddFees] = useState(null);
    const [data, setData] = useState([]);
      const [error, setError] = useState('');
       const [loading, setLoading] = useState(true);
       const [search, setSearch] = useState('');
    const closeModal = () => setActiveForm(null);
        const closeForm = () => setActiveForm(null);
         const [activeForm, setActiveForm] = useState(null); 
         const [selectedRow, setSelectedRow] = useState(null);

    const [formData, setFormData] = useState({
      CLASS: '',
      SECTION: '',
      DOADM: new Date().toISOString().split('T')[0],
      SHIFT: ''
    });
  

  const handleInputChange = (index, field, value) => {
    const updated = [...feeDetails];
    updated[index][field] = value;
    setFeeDetails(updated);
  };

  const handleOpenDiscountModal = (index) => {
    setTempDiscount(feeDetails[index].discount || '');
    setTempDiscountType(feeDetails[index].discountType || '');
    setTempDiscountRemarks(feeDetails[index].discountRemark || '');
    setDiscountModalIndex(index);
  };

const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleShiftChange = (e) => {
    const selectedShift = e.target.value;
    setFormData(prev => ({
      ...prev,
      SHIFT: selectedShift,
    }));
    fetchFeeDetails(formData.PLACE, selectedShift);
  };

  const handleSaveDiscount = () => {
     if (discountModalIndex !== null) {
      const idx = discountModalIndex;
      const oldFee = feeDetails[idx];
      const oldFeeAmount = parseFloat(oldFee.FEES) || 0;
      const oldDiscount = parseFloat(oldFee.discount) || 0;
      const oldPayable = oldFeeAmount - oldDiscount;
      const oldPaid = parseFloat(oldFee.current) || 0;

      const newDiscount = parseFloat(tempDiscount) || 0;
      const newPayable = oldFeeAmount - newDiscount;

      const updated = [...feeDetails];
      updated[idx].discount = tempDiscount;
      updated[idx].discountType = tempDiscountType;
      updated[idx].discountRemark = tempDiscountRemarks;

      // ✅ Update paid amount if user had paid full earlier
      if (oldPaid === oldPayable) {
        updated[idx].current = newPayable.toFixed(2);
      }

      setFeeDetails(updated);
      setDiscountModalIndex(null);
    }
  };

  const handleCancelDiscount = () => {
    setDiscountModalIndex(null);
  };


  const fetchFeeDetails = async (place, shift) => {
    if (!place || !shift) return;

    const url = AppStrings.VanFeesDetails + `?TYPE=${encodeURIComponent(shift)}&PLACE=${encodeURIComponent(place)}`;

    try {
      const response = await fetch(url);
      const data = await response.json();
      const feeArray = Array.isArray(data.data) ? data.data : data?.data?.result || [];
console.log(feeArray[0].FEES,'JJJJJJJJJJJJJJ')
setAddFees(feeArray[0].FEES);
      const formatted = feeArray.map(item => ({
        ...item,
        current: '',
        discount: '',
        discountType: '',
        discountRemark: ''
      }));
      console.log('lllllllllllllllll',formatted)

      setFeeDetails(formatted);
    } catch (error) {
      console.error('Error fetching fee data:', error);
      setFeeDetails([]);
    }
  };

  const totalPaid = feeDetails.reduce((sum, fee) => sum + (parseFloat(fee.current) || 0), 0);

  const handleYesNo = () => {
  setShowConfirmModal(true);
};

  const handleSubmit = async () => {
    const payload = {
      student: {
        ID:studentData.id,
         PICKUPPLACE: formData.PLACE,
         PICKUPTYPE: formData.SHIFT,
         ADDITIONALFEESID:formData.TYPE,
         PAYTYPE:'B',
         TERMTYPE:formData.TERM,
         AMOUNT:AddFees,
         USERNAME:studentData.username
      },
    };

    try {
      const res = await fetch(AppStrings.AdditionalFeeSave, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const result = await res.json();
      //setPrintRefNo(result.data[0].REFNO);
      alert(result.message || "Data saved successfully!");

       fetchStudentData();

      // handleCancel();
      // onClose();
    } catch (err) {
      console.error("Error:", err);
      alert("Failed to save data.");
    }
  };

  const handleCancel = () => {
    setFeeDetails([]);
  };

  useEffect(() => {
   
    handlePayClick();
     fetchStudentData();
  }, []);

  useEffect(() => {
    if (discountModalIndex !== null && discountInputRef.current) {
      discountInputRef.current.focus();
    }
  }, [discountModalIndex]);

    const fetchStudentData = async () => {
    try {
      const response = await axios.get(AppStrings.AdditionalFeeList+`?studentid=${studentData.id}`);
      const result = response.data.data.result || response.data.data;
console.log(result,'res')
      if (Array.isArray(result)) {
        setData(result);
        setError('');
      } else {
        setError('Unexpected response format');
        console.warn('Expected an array but got:', result);
      }
    } catch (err) {
      setError('Failed to fetch data');
      console.error("Fetch error:", err.message || err);
    } finally {
      setLoading(false);
    }
  };
 

  const handlePayClick = async () => {
    const feeType = studentData.addfees;
    const className = studentData.class;
    const type = 'N';
    const AdmissionID=studentData.id

    if (!feeType || !className) {
      alert('Missing class or fee type for this student.');
      return;
    }

    //setSelectedRow(row);
    setFormData({ PLACE: '', SHIFT: '' });
    setFeeDetails([]);

    
console.log(AdmissionID,'45555');

      const url = AppStrings.BusDetails+`?studentid=${AdmissionID}`;

      try {
        const response = await fetch(url);
        const data = await response.json();
console.log(data,'kkkkkk');
        const feeArray = Array.isArray(data.data) ? data.data : data.data?.data.data?.result || [];
        console.log(feeArray,'feaaaaaaaaeeeeeeeeeee');
        const formatted = feeArray.map(item => ({
          ...item,
          current: '',
          discount: ''
        }));

        setFeeDetails(formatted);
        console.log(feeDetails,'feeeeeeeeeeee');
      } catch (error) {
        console.error('Error fetching fee data:', error);
        setFeeDetails([]);
      }
    
  };


  console.log('feeDetails:', feeDetails);  // For debugging
  console.log(selectedRow, 'ssssssssss');  // ✅ Valid place


  return (
    <div style={modalOverlayStyle}>
      <div style={modalStyle}>
        {studentData && (
          <div style={{ marginBottom: '15px', textAlign: 'center' }}>
            <strong>Student:</strong> {studentData.name} | <strong>Id:</strong> {studentData.id}
          </div>
        )}

        <div className="row">
          <div className="col-201">
          <AdditionalTypeList
  value={formData.TYPE || ''}
  onChange={(e) => handleFormChange({ target: { name: 'TYPE', value: e.target.value } })}
/>
          </div>
         {formData.TYPE === 'VAN FEES' && (
  <div className="col-701">
    <div className="coolinput">
      <BusSelect
        value={formData.PLACE || ''}
        onChange={(e) => handleFormChange({ target: { name: 'PLACE', value: e.target.value } })}
        style={{ height: '40px' }}
      />
    </div>
  </div>
)}
          <div className="col-201">
            <label style={{ marginRight: '10px' }}>
              <input
                type="radio"
                name="SHIFT"
                value="P"
                checked={formData.SHIFT === "P"}
                onChange={handleShiftChange}
              />
              Full
            </label>
            <label>
              <input
                type="radio"
                name="SHIFT"
                value="H"
                checked={formData.SHIFT === "H"}
                onChange={handleShiftChange}
              />
              Half
            </label>
          </div>

        
           <div className="col-701">
            <div className="coolinput">
              <TermTypeList
  value={formData.TERM || ''}
  onChange={(e) => handleFormChange({ target: { name: 'TERM', value: e.target.value } })}
/>
            </div>
          </div>
          <div className="col-701">
            <div className="coolinput">
             <input
                  ref={discountInputRef}
                  type="text"
                  placeholder="Amount"
                  className="input PayInPut"
                  value={AddFees}
                  onChange={(e) => setAddFees(e.target.value)}
                />
            </div>
          </div>
        </div>

       

   
<div style={{ textAlign: 'right' }}>
        <button style={MastAddNewBtn} onClick={handleYesNo}>Add</button>
        <button style={MastAddNewBtn} onClick={onClose}>Close</button>
        </div>

          {!loading && !error && Array.isArray(data) && (
        <div style={{ maxHeight: '530px', overflowY: 'auto', border: '1px solid #ccc' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f2f2f2' }}>
                <th style={{ ...headerCellStyle, width: '100px' }}>Additional Type</th>
                <th style={{ ...headerCellStyle, width: '300px' }}>Place</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Type</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Term</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Amount</th>
                <th style={headerCellStyle}></th>
              </tr>
            </thead>
            <tbody>
              {data
                
                .map((row, index) => (
                  <tr key={index}>
                    <td style={cellStyle}>{row.TYPE}</td>
                    <td style={cellStyle}>{row.PLACE}</td>
                    <td style={cellStyle}>{row.PICKUPTYPE}</td>
                    <td style={cellStyle}>{row.FEESTYPE}</td>
                    <td style={cellStyle}>{row.AMOUNT}</td>
                    <td style={cellStyle}>
                      <button className="GridButton1"  onClick={() => {
  setSelectedRow(row);        
  setActiveForm('Cancel');      
             }}>Delete</button>
                      {/* <button className="GridButton" onClick={handleCancel}>Cancel</button> */}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}


{activeForm && (
         <>
            {activeForm === 'Cancel' && (
             
               <CancelForm  onClose={() => {
    fetchStudentData(); // ✅ Refresh table
    setSelectedRow(null);
    setActiveForm(null);
  }}
  studentData={{
     RefNo:selectedRow.REFNO,
     Amount:selectedRow.AMOUNT,
     Term:selectedRow.FEESTYPE,
     Id:studentData.id,
     VouNo:'',
     SNo:'',
     username:studentData.username
    }} />
              
            )}
         </>
      )}

      {showConfirmModal && (
  <div style={modalOverlayStyle}>
    <div style={{ ...modalStyle, width: '300px', textAlign: 'center' }}>
      <h3>Confirm Save</h3>
      <p>Are you sure you want to save this data?</p>
      <div style={{ marginTop: '15px' }}>
        <button
          onClick={() => {
            setShowConfirmModal(false);
            handleSubmit(); // ✅ proceed with actual submission
          }}
        >
          Yes
        </button>
        <button
          onClick={() => setShowConfirmModal(false)}
          style={{ marginLeft: '10px' }}
        >
          No
        </button>
      </div>
    </div>
  </div>
)}

       {/* {activeForm && (
        <div style={modalOverlayStyle} onClick={closeModal}>
          <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
         
              {activeForm === 'Fees'&& selectedRow &&(
              <>
                          <CancelForm
    studentData={{
     Refo:selectedRow.REFNO,
     AMOUNT:selectedRow.AMOUNT,
     Term:selectedRow.FEESTYPE,
     Id:studentData.id
    }}
    onClose={() => {
      setActiveForm(null);
      setSelectedRow(null);
      //setFeeDetails([]);
    }}
  />    
              </>
            )}
          
          </div>
        </div>
      )} */}

      
      </div>
    </div>
  );
}

export default AdditionalFeesForm;

// === Styles ===



const MastAddNewBtn = {
  textAlign: 'center',
   padding:10,
   //backgroundColor:"red",
    //color:'black',
    marginTop: '15px'
};

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
};

const modalStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '8px',
  width: '900px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
};

const headerCellStyle = {
  padding: '8px',
  backgroundColor: '#f2f2f2',
};

const cellStyle = {
  padding: '4px',
  fontSize: '13px',
};
